import { StaticQuery, graphql } from "gatsby"
import React from "react"

const Copyright = () => (
  <StaticQuery
    query={query}
    render={({
      site: {
        siteMetadata: { copyright },
      },
    }) => <p>{copyright}</p>}
  />
)

export default Copyright

const query = graphql`
  query Copyright {
    site {
      siteMetadata {
        copyright
      }
    }
  }
`
